import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { StopConnection, TimetableCity } from '@/new-transport/_models/transport-timetable.model';
import { NgTemplateOutlet } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { pipe, tap } from 'rxjs';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { createStopConnection } from '@/new-transport/_factory/stop-connection.factory';

@Component({
	selector: 'app-stop-connection-modal',
	standalone: true,
	imports: [
		MatDialogTitle,
		MatDialogContent,
		NgTemplateOutlet,
		MatDialogActions,
		MatButton,
		MatDialogClose,
		ReactiveFormsModule,
		MatLabel,
		MatError,
		MatInput,
		MatSuffix,
		MatFormField,
	],
	templateUrl: './stop-connection-modal.component.html',
	styleUrl: './stop-connection-modal.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StopConnectionModalComponent implements OnInit {
	readonly data = inject<{ stopConnection: StopConnection; stopFrom: TimetableCity; stopTo: TimetableCity }>(
		MAT_DIALOG_DATA,
	);

	readonly stopConnectionForm: FormGroup = new FormGroup({
		minutes: new FormControl(null, [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$')]),
		kilometers: new FormControl(null, [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$')]),
	});

	private readonly minutes = signal<number>(null);
	private readonly kilometers = signal<number>(null);

	private readonly destroyRef = inject(DestroyRef);
	private readonly dialogRef = inject(MatDialogRef);

	private readonly updateInputValues = rxMethod<{ minutes: number; kilometers: number }>(
		pipe(
			takeUntilDestroyed(this.destroyRef),
			tap(({ minutes, kilometers }) => {
				this.minutes.set(minutes);
				this.kilometers.set(kilometers);
			}),
		),
	);

	ngOnInit(): void {
		this.updateInputValues(this.stopConnectionForm.valueChanges);

		if (this.data.stopConnection) {
			this.stopConnectionForm.get('minutes').setValue(this.data.stopConnection.minutes);
			this.stopConnectionForm.get('kilometers').setValue(Number(this.data.stopConnection.kilometers));
		}
	}

	emitSaveStopConnection(): void {
		const stopConnection: StopConnection = this.data.stopConnection
			? {
					...this.data.stopConnection,
					kilometers: this.kilometers(),
					minutes: this.minutes(),
				}
			: createStopConnection(null, this.data.stopFrom.id, this.data.stopTo.id, this.kilometers(), this.minutes());

		this.dialogRef.close(stopConnection);
	}
}
